<template>
  <v-container class="pa-2" fluid v-if="instansi">
    <m-card
      title="Profil Instansi"
      :edit="isCan(`${$consts.ROLE_OWNER.name}|${$consts.ROLE_ADMIN_DESA.name}`) && this.CONFIG.SINGKRONISASI != 'true'"
      @edit="edit"
      hint="Menu ini berisi informasi dasar desa"
      :print="isCan(`${$consts.ROLE_OWNER.name}|${$consts.ROLE_ADMIN_INSTITUSI.name}`)"
      @cetak="cetak"
    >
      <v-row>
        <v-col cols="12" sm="3" md="3" lg="3" xl="3" class="pr-2">
          <v-card
            flat
            color="primary"
            min-height="200"
            max-height="200"
            :img="instansi.logo || 'img/office.png'"
            tile
          >
            <v-list-item three-line>
              <v-list-item-content>
                <v-btn
                  v-if="isCan(`${$consts.ROLE_OWNER.name}|${$consts.ROLE_ADMIN_DESA.name}`)"
                  fab
                  depressed
                  small
                  color="white"
                  style="position: absolute;right: 2px;top: 5px;"
                  id="pick-avatar"
                >
                  <v-icon>mdi-camera-outline</v-icon>
                </v-btn>
                <avatar-cropper
                  v-if="isCan(`${$consts.ROLE_OWNER.name}|${$consts.ROLE_ADMIN_DESA.name}`)"
                  @uploading="handleUploading"
                  @uploaded="handleUploaded"
                  @completed="handleCompleted"
                  @error="handlerError"
                  :cropper-options="{aspectRatio: 1,initialAspectRatio:NaN,cropBoxResizable:true,minCropBoxWidth:50,minCropBoxHeight:50}"
                  :output-options="{width: 400}"
                  trigger="#pick-avatar"
                  :upload-url="urlUploadPhoto"
                  :upload-headers="token"
                  :upload-form-data="{instansi_id:this.instansi_id,jenis:'logo'}"
                  :labels="{submit:'Simpan',cancel:'Hapus'}"
                />
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" md="8" lg="8" xl="8" class="pl-1">
          <v-card
            flat
            color="primary"
            :img="instansi.cover||'img/parallax.png'"
            min-height="200"
            max-height="200"
            tile
          >
            <!-- <v-img
              class="align-end"
              max-height="200px"
              aspect-ratio="1.7"
              :output-options="{width: 400}"
              :src="instansi.cover||'img/parallax.png'"
            >-->
            <!-- <v-btn
                v-if="isCan(`${$consts.ROLE_OWNER.name}|${$consts.ROLE_ADMIN_DESA.name}`)"
                fab
                depressed
                color="white"
                small
                style="position: absolute;right: 2px;top: 5px;"
                id="pick-cover"
              >
                <v-icon>mdi-camera-outline</v-icon>
              </v-btn>
              <avatar-cropper
                @uploading="handleUploading"
                @uploaded="handleUploaded"
                @completed="handleCompleted"
                @error="handlerError"
                :cropper-options="{aspectRatio: 21/9,initialAspectRatio:NaN,cropBoxResizable:true,minCropBoxWidth:50,minCropBoxHeight:50}"
                trigger="#pick-cover"
                :upload-url="urlUploadCover"
                :upload-headers="token"
                :upload-form-data="{instansi_id:this.instansi_id,jenis:'cover'}"
                :labels="{submit:'Simpan',cancel:'Hapus'}"
            />-->
            <!-- </v-img> -->
            <v-list-item three-line>
              <v-list-item-content class="align-self-start">
                <v-btn
                  v-if="isCan(`${$consts.ROLE_OWNER.name}|${$consts.ROLE_ADMIN_DESA.name}`)"
                  fab
                  depressed
                  small
                  color="white"
                  style="position: absolute;right: 2px;top: 5px;"
                  id="pick-cover"
                >
                  <v-icon>mdi-camera-outline</v-icon>
                </v-btn>
                <avatar-cropper
                  @uploading="handleUploading"
                  @uploaded="handleUploaded"
                  @completed="handleCompleted"
                  @error="handlerError"
                  :cropper-options="{aspectRatio: 8/5,initialAspectRatio:NaN,cropBoxResizable:true,minCropBoxWidth:50,minCropBoxHeight:50}"
                  :output-options="{width: 400}"
                  trigger="#pick-cover"
                  :upload-url="urlUploadPhoto"
                  :upload-headers="token"
                  :upload-form-data="{instansi_id:this.instansi_id,jenis:'cover'}"
                  :labels="{submit:'Simpan',cancel:'Hapus'}"
                />
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="12"
          v-if="instansi && instansi.meta && instansi.meta.length>0"
        >
          <span class="display-1 primary--text ml-5">{{pVal(instansi,'nama')}}</span>
          <v-row>
            <v-col
              cols="12"
              md="4"
              lg="4"
              class="pa-0 ml-5"
              v-for="item in instansi.meta"
              :key="item.key"
            >
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-subtitle>{{pVal(item,'key')}}</v-list-item-subtitle>
                  <v-list-item-title class="font-weight-bold">{{pVal(item,'value')}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
          <!-- <v-simple-table>
            <tbody>
              <tr v-for="item in instansi.meta" :key="item.key">
                <td class="font-weight-bold">{{pVal(item,'key')}}</td>
                <td>{{pVal(item,'value')}}</td>
              </tr>
            </tbody>
          </v-simple-table>-->
        </v-col>
      </v-row>
    </m-card>
    <ChangeDlg ref="dlg" />
  </v-container>
</template>
<script>
import { API } from "../../../const";
import AvatarCropper from "vue-avatar-cropper";
import ChangeDlg from "../components/Form.vue";
// const lc = window.localStorage
// const INSTANSI_AKTIF = 'monev_mt_inst'
export default {
  components: {
    AvatarCropper,
    ChangeDlg
  },
  data() {
    return {
      allow: false,
      instansi: null,
      message: "",
      token: {
        Authorization: `Bearer ${window.localStorage.getItem("monevmt")}`
      },
      urlUploadCover: null,
      urlUploadPhoto: null
    };
  },
  computed: {},
  activated() {
    this.urlUploadPhoto = API + "/api/instansi/" + this.instansi_id + "/image";
    this.urlUploadCover = API + "/api/instansi/" + this.instansi_id + "/image";
    this.load();
  },
  methods: {
    load() {
      this.$store
        .dispatch("instansi/detail", this.instansi_id)
        .then(res => {
          this.instansi = res;
        })
        .catch(e => e);
    },
    cetak() {
      if (this.instansi && this.instansi.user_institusi) {
        return this.$store
          .dispatch("member/cetak", {
            instansi_id: this.current_instansi.id,
            obj: this.instansi.user_institusi.user
          })
          .catch(e => e);
      }
    },
    reloadInstansi(item) {
      this.$store
        .dispatch("instansi/switchInstansi", item.id)
        .then(() => {
          this.load();
        })
        .catch(e => e);
    },
    edit() {
      this.$refs.dlg.open(this.instansi).then(() => {
        this.load();
      });
    },
    // eslint-disable-next-line
    handleUploaded(response) {
      if (response.status) {
        // this.message = "Load photo..";
      }
    },
    // eslint-disable-next-line
    handleUploading(form, xhr) {
      this.message = "uploading...";
    },
    // eslint-disable-next-line
    handleCompleted(commit, response, form, xhr) {
      this.$info("Update Foto Berhasil");
      this.message = "";
      this.reloadInstansi(this.instansi);
    },
    // eslint-disable-next-line
    handlerError(message, type, xhr) {
      // this.$error("Update Foto Gagal");
      this.message = "Oops! Something went wrong...";
    },
    close() {
      this.$router.push({
        name: "instansi"
      });
    }
  },
  watch: {
    instansi_id() {
      this.load();
    }
  }
};
</script>
